export const EMAIL_VALIDATION_ERRORS = {
    NOT_VALID: 405, // The email is not valid
    USED: 407, // The email already exists
};

export const ROLES = {
    SALES_REP: 'SALES_REP',
    MANAGER: 'MANAGER',
    ADMIN: 'ADMIN',
};

export const OPPORTUNITY_STATUS = {
    OPEN: 'OPEN',
    WON: 'WON',
    LOST: 'LOST',
};

export const ORDER_STATUS = {
    OPEN: 'OPEN',
    WON: 'WON',
    LOST: 'LOST',
};

export const types = {
    LOADING: 'LOADING',
    DATA: 'DATA',
    CLOSE_MODAL: 'CLOSE_MODAL',
    OPEN_MODAL: 'OPEN_MODAL',
    UPDATE_MODAL: 'UPDATE_MODAL',
    MODAL_EDIT: 'MODAL_EDIT',
    MODAL_ADD: 'MODAL_ADD',
    MODAL_ADD_SINGLE: 'MODAL_ADD_SINGLE',
    DRAG_ENTER: 'DRAG_ENTER',
};

export const TABLES = {
    INVITED_USERS: 'invitedUsers',
    ACCOUNT_TYPES: 'accountTypes',
    SALES_ORDER_STATUS: 'salesorderStatuses',
    OPPORTUNITY_STATUS: 'opportunityStatuses',
};
